module.exports = paginationCard = {

  getDivisionLatLng: (pageConfig) ->
    return pageConfig.ell if pageConfig.ell
    return "#{pageConfig.currentDivision.lat},#{pageConfig.currentDivision.lng}" if pageConfig.currentDivision?.lat
    return null

  getDivisionLocale: (pageConfig) ->
    return pageConfig.currentDivision.defaultLocale if pageConfig.currentDivision.defaultLocale
    return I18n.locale

  clonableAttributes: [
    'data-limit'
    'data-deal-type'
    'data-is-category-fallback'
    'data-category-fallback'
    'data-filter-query'
    'data-context'
    'data-division'
    'data-division-loc'
    'data-page-type'
    'data-show-options'
    'data-set-label'
    'data-set-id'
    'data-nohero'
    'data-unsafe-deals'
    'data-href-template'
    'data-inclue-query'
  ]

  cloneAttributes: (node, attrList)->
    newMap = {}
    attrList = attrList || this.clonableAttributes
    Array.from(attrList).forEach (attr)->
        value = node.getAttribute(attr)
        newMap[attr] = value if value
    return newMap

  campaignFilteringAttrs: (pageConfig) ->
    # this response object is the same format as loadButtonAttributes
    # and for use with apiQueryBuilder
    obj=Object.assign({}, pageConfig.occasion)
    obj.includeHtml = pageConfig.newRender
    obj.divisionLocale = @getDivisionLocale(pageConfig)
    obj.latLng = @getDivisionLatLng(pageConfig)
    obj.pageType = pageConfig.occasion.apiRapiPageType # do not simply auto name this correctly server side, template render will be effected
    obj.noHero = pageConfig.isTouch
    return obj

  loadButtonAttributes: (loadMoreBtn, pageConfig) ->
    # PLEASE NOTE: this is only for pagination cards, apiQueryBuilder is also called from facetSelectionChanged
    # the easy way to get properties for free there is to define them on pageConfig.occasion instead of pageConfig
    # it is arguable we will simply default the object we return here with pageConfig.occasion to simplify this code
    dealType: loadMoreBtn.getAttribute("data-deal-type")
    isCategoryFallback: loadMoreBtn.getAttribute("data-is-category-fallback")
    categoryFallback: loadMoreBtn.getAttribute("data-category-fallback")
    context: loadMoreBtn.getAttribute("data-context")
    division: loadMoreBtn.getAttribute("data-division") or pageConfig.occasion.division
    sort: pageConfig.sort or false
    noHero: loadMoreBtn.getAttribute("data-nohero") or pageConfig.isTouch or false
    filterQuery: loadMoreBtn.getAttribute("data-filter-query") unless loadMoreBtn.getAttribute("data-inclue-query")
    pageType: loadMoreBtn.getAttribute("data-page-type")
    latLng: loadMoreBtn.getAttribute("data-division-loc") or @getDivisionLatLng(pageConfig)
    divisionLocale: @getDivisionLocale(pageConfig)
    divisionTz: pageConfig.currentDivision?.timezoneIdentifier
    includeHtml: pageConfig.newRender or false
    renderOptions: pageConfig.occasion.renderOptions or false
    unsafe: loadMoreBtn.getAttribute("data-unsafe-deals")
    showOptions: loadMoreBtn.getAttribute("data-show-options") or "false"
    showBestOption: pageConfig.occasion.showBestOption
    showUrgentPerc: pageConfig.occasion.showUrgentPerc
    extraShow: pageConfig.occasion.extraShow
    extraRapiShow: pageConfig.occasion.extraRapiShow
    apiFacets: pageConfig.occasion.apiFacets
    includeQuery: loadMoreBtn.getAttribute("data-inclue-query") or false

  copyDataAttributes: (source, destination) ->
    for i in source.attributes
      if i.nodeName.indexOf('data-') == 0
        destination.setAttribute(i.nodeName, i.nodeValue)

}
